import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionTypes from "actions/actionTypes";
import Inputmask from "inputmask"

import {
  selectInitialFormFields,
  selectAdditionalFormFields,
  selectCurrentStateName,
  selectCurrentWIVehicleObject,
  selectCanSave,
  selectDropDownStates
} from "selector/initializeSelector";
import {
  fetchFieldsAction,
  requestChangeInputValueAction,
  createWorkItemAction,
  cancelWorkItemAction,
  generateWorkItemReportAction,
  changeStateCloneWorkItem,
  addMiscFee,
  setMiscFeeValue,
  setPre1981DataValue
} from "actions/questionaireActions";
import WorkItemForm from "components/WorkItem/Form";
import withUnmountAction from "enhancers/withUnmountAction";

const mapField = field => {
  if(field.maxLength == null){
    if (field.key === "cClaim" || field.key === "cInsurer") {
      return { ...field, maxLength: 50 };
    }
    if (field.key === "cAddress") {
      return { ...field, maxLength: 100 };
    }
    if (field.key === "cRegZip") {
      return { ...field, maxLength: 10 };
    }
  }

  return field;
};

export const mapStateToProps = state => {
  const initialFields = selectInitialFormFields(state).map(mapField);

  const sections = [
    {
      hasNext: true,
      header: selectCurrentStateName(state),
      fields: initialFields,
      isCloned: state.workItems.currentWorkItem === null ? false : (state.workItems.currentWorkItem.attributes.isClone === "True"),
      listItems: selectDropDownStates(state),
      workitemId: state.workItems.currentWorkItem === null ? false : (state.workItems.currentWorkItem.workItemId),
    }
  ];
  const additionalFields = selectAdditionalFormFields(state).map(mapField);
  let vehicle = null;
  try {
      vehicle = selectCurrentWIVehicleObject(state);
      if (vehicle.year == "2000" && vehicle.make === undefined && vehicle.model === undefined) {
          vehicle = null;
      }
  } catch (e) {
    vehicle = null;
  }
  if (additionalFields.length) {
    const claimTypeValue = initialFields.filter(a => a.key === "cOwnerRet")[0].value
    let claimTypeItems = [];
    switch(claimTypeValue){
      case "No":
        claimTypeItems.push("Insurer Retained");
        break;
      case "Yes":
        claimTypeItems.push("Owner Retained");
        break;
      case "Dual":
      default:
        claimTypeItems.push("Insurer Retained");
        claimTypeItems.push("Owner Retained");
        break;
    }
    
    sections.push({
      hasNext: false,
      header: `Additional Information`,
      vehicle: vehicle,
      fields: additionalFields,
      sectionMessage: state.workItems.nextSectionMessage,
      miscFees: state.workItems.miscFees,
        pre1981Data: state.workItems.pre1981Data,
      claimTypeItems: claimTypeItems
    });
    }


  Inputmask().mask(document.querySelectorAll("input"));

  return {
    sections,
    showFooter: !!additionalFields.length,
    canSave: selectCanSave(state),
    onFieldsNext: state.workItems.onFieldsNext,
    nextSection: state.workItems.nextSection,
    nextSectionMessage: state.workItems.nextSectionMessage,
    redirectBack: initialFields.length === 0,
    features: state.features,
    stateName: selectCurrentStateName(state)
  };
};

export const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      onClickNext: fetchFieldsAction,
      onFieldChange: requestChangeInputValueAction,
      onChangeState: changeStateCloneWorkItem,
      onAddMiscFee: addMiscFee,
      onSetMiscFeeValue: setMiscFeeValue,
      onSetPre1981DataValue: setPre1981DataValue,
      onCancel: cancelWorkItemAction,
      onGenerateReport: sections => {
        let fields = sections.reduce(
          (fields, section) => fields.concat(section.fields),
          []
        );
        return generateWorkItemReportAction(fields);
      },
      onSave: sections => {
        const fields = sections.reduce(
          (fields, section) => fields.concat(section.fields),
          []
        );
        return createWorkItemAction(fields);
      }
    },
    dispatch
  );
};

export default withUnmountAction({ type: actionTypes.RESET_ERROR })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WorkItemForm)
);
